<template>
  <div class="date-time-picker">
    <van-popup v-model="visible" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        :type="type"
        :min-date="min"
        :max-date="max"
        @cancel="cancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Popup, DatetimePicker } from "vant";
import { formatDate } from "@/utils/common";

export default {
  name: "DateTimePicker",
  components: {
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "date"
    },
    minDate: {
      type: String,
      default: ""
    },
    maxDate: {
      type: String,
      default: ""
    },
    format: {
      type: String,
      default: ""
    },

    change: { type: Function }
  },
  data() {
    return {
      visible: false,
      currentDate: ""
    };
  },
  created: function() {
    if (this.value) {
      this.currentDate = new Date(this.value);
    }
  },
  mounted() {
    this.visible = true;
  },
  computed: {
    min() {
      if (this.minDate) {
        return new Date(this.minDate);
      } else {
        return new Date(1900, 1, 1);
      }
    },
    max() {
      if (this.maxDate) {
        return new Date(this.maxDate);
      } else {
        return new Date();
      }
    }
  },
  methods: {
    onConfirm(data) {
      let date = data;
      if (this.format) {
        date = formatDate(data, this.format);
      }
      this.$emit("change", date);
      this.cancel();
    },
    cancel() {
      this.visible = false;
      this.$emit("destroy");
    }
  }
};
</script>

<style lang="less"></style>
